/** Gliederungs-Hilfen der Richtlinien-Werkstatt (Abschnitte in Lesereihenfolge, `level` ab 1). */

/** Index hinter dem Abschnitt samt seinen Unterabschnitten — dort landet ein neuer Abschnitt. */
export const subtreeEnd = (sections: Array<{ _id: string; level: number }>, id: string): number => {
  const i = sections.findIndex((s) => s._id === id);
  if (i < 0) return -1;
  let j = i + 1;
  while (j < sections.length && sections[j].level > sections[i].level) j++;
  return j;
};

/** Überschriftzeile eines Entwurfs auf den neuen Titel setzen („## 4.7.1a Alter Titel" → neuer Titel). */
export const retitle = (text: string, number: string, title: string): string => {
  const heading = `## ${number} ${title}`;
  return /^\s*#{1,6} [^\n]*/.test(text) ? text.replace(/^\s*#{1,6} [^\n]*/, heading) : `${heading}\n\n${text}`;
};
